<template>
  <div class="main-panel">
    <div class="nav-bar-operations">
      <img
        src="@/assets/logogruas.png"
        alt="HomePage"
        class="logo-button"
        @click="backMainPanel"
      />
    </div>

    <header class="header">
      <div class="header__left">
        <div class="avatar" aria-hidden="true">N</div>
        <div class="greet">
          <h1>Calcular <span>Nomina</span></h1>
          <p class="sub">Calculo de nomina semanal por empresa</p>
        </div>
      </div>
      <button class="back-btn" @click="goBackToMenu">Volver a Nomina</button>
    </header>

    <section class="content" :class="{ 'content--wide': showReport }">
      <div class="controls" v-if="!showReport">
        <label class="field">
          Año
          <input type="number" v-model.number="selectedYear" min="2000" max="2100" />
        </label>
        <label class="field grow">
          Seleccione una semana
          <select v-model="selectedPayrollWeekKey">
            <option v-for="week in payrollWeeks" :key="week.key" :value="week.key">
              {{ payrollWeekLabel(week) }}
            </option>
          </select>
        </label>

        <button class="refresh-btn" @click="fetchCompanies" :disabled="loading || !selectedPayrollWeek">
          {{ loading ? 'Actualizando...' : 'Actualizar' }}
        </button>
      </div>

      <section v-if="error" class="error-box">{{ error }}</section>

      <section v-if="selectedPayrollWeek && !loading && warning" class="warning-box">
        <strong>No se puede calcular la nomina de esta semana todavia.</strong>
        <p>{{ warning }}</p>
      </section>

      <div class="table-wrap" v-if="selectedPayrollWeek && !showReport">
        <table class="payroll-table">
          <colgroup>
            <col style="width: 7%" />
            <col style="width: 13%" />
            <col style="width: 8%" />
            <col style="width: 9%" />
            <col style="width: 8.5%" />
            <col style="width: 8.5%" />
            <col style="width: 8.5%" />
            <col style="width: 30%" />
            <col style="width: 7%" />
          </colgroup>
          <thead>
            <tr>
              <th>Procesar</th>
              <th class="text-left">Empresa</th>
              <th>Estatus</th>
              <th>Fecha de Creacion</th>
              <th>Total Banregio1</th>
              <th>Total Banregio2</th>
              <th>Total Percepcion</th>
              <th>Reportes</th>
              <th>Cerrar Nomina</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loading">
              <td colspan="9" class="empty-cell">Cargando empresas...</td>
            </tr>
            <tr v-else-if="!companies.length">
              <td colspan="9" class="empty-cell">No se encontraron empresas asignadas a empleados.</td>
            </tr>
            <tr v-for="row in companies" :key="row.company">
              <td>
                <button
                  class="calc-btn"
                  :disabled="!row.can_calculate || calculatingCompany === row.company"
                  :title="row.reason || ''"
                  @click="onCalcular(row)"
                >
                  {{ calculatingCompany === row.company ? 'Calculando...' : (isCalculated(row) ? 'Recalcular' : 'Calcular') }}
                </button>
                <div v-if="cutoffPassed && !row.file_uploaded" class="missing-file">
                  Falta archivo
                </div>
              </td>
              <td class="text-left company-cell">{{ row.company }}</td>
              <td>
                <span class="status-badge" :class="isCalculated(row) ? 'status-badge--ok' : 'status-badge--pending'">
                  {{ row.status }}
                </span>
              </td>
              <td>{{ isCalculated(row) ? formatDate(row.created_at) : 'No calculado' }}</td>
              <td>{{ formatTotal(row, row.total_banregio1) }}</td>
              <td>{{ formatTotal(row, row.total_banregio2) }}</td>
              <td>{{ formatTotal(row, row.total_percepcion) }}</td>
              <td>
                <div class="report-actions">
                  <button
                    class="report-btn"
                    :disabled="!isCalculated(row)"
                    :title="isCalculated(row) ? '' : 'Debes calcular la nomina primero.'"
                    @click="onDetalle(row)"
                  >
                    Detalle
                  </button>
                  <button
                    class="report-btn"
                    :disabled="!isCalculated(row)"
                    :title="isCalculated(row) ? '' : 'Debes calcular la nomina primero.'"
                    @click="onRepBanco(row)"
                  >
                    Rep. Banco
                  </button>
                  <button
                    class="report-btn"
                    :disabled="!isCalculated(row)"
                    :title="isCalculated(row) ? '' : 'Debes calcular la nomina primero.'"
                    @click="onDispersion(row)"
                  >
                    Dispersion
                  </button>
                  <button
                    class="report-btn"
                    :disabled="!isCalculated(row)"
                    :title="isCalculated(row) ? '' : 'Debes calcular la nomina primero.'"
                    @click="onPrestamos(row)"
                  >
                    Complemento
                  </button>
                </div>
              </td>
              <td>
                <button
                  class="close-btn"
                  :disabled="!isCalculated(row)"
                  :title="isCalculated(row) ? '' : 'Debes calcular la nomina primero.'"
                  @click="onCerrar(row)"
                >
                  Cerrar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="definitions" v-if="selectedPayrollWeek && !showReport">
        <h3>Definiciones</h3>
        <table class="definitions-table">
          <tbody>
            <tr>
              <td>Total Banregio1</td>
              <td>Nomina Microsip.</td>
            </tr>
            <tr>
              <td>Total Banregio2</td>
              <td>Complemento.</td>
            </tr>
            <tr>
              <td>Total Percepcion</td>
              <td>Pago total.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Report view (replaces the company table) -->
      <div class="detalle-view" v-if="showReport && reportData">
        <div class="detalle-header">
          <button class="back-btn" @click="closeReport">&larr; Volver</button>
          <h2>
            {{ reportTitle }} &mdash; {{ reportData.company }}
            <span class="detalle-sub">Semana {{ reportData.week_index }}</span>
          </h2>
          <div class="report-download">
            <button class="dl-btn dl-btn--csv" :disabled="downloading" @click="downloadReport('csv')">
              Descargar CSV
            </button>
            <button class="dl-btn dl-btn--xlsx" :disabled="downloading" @click="downloadReport('xlsx')">
              Descargar XLSX
            </button>
            <button
              v-if="reportData && ['dispersion', 'complemento'].includes(reportData.report)"
              class="dl-btn dl-btn--banregio"
              :disabled="downloading"
              @click="downloadReport('banregio')"
            >
              Layout Banregio
            </button>
          </div>
        </div>
        <div class="detalle-wrap" v-if="reportData.rows && reportData.rows.length">
          <table class="detalle-table">
            <thead>
              <tr>
                <th
                  v-for="col in reportData.columns"
                  :key="col.key"
                  :class="{ 'col-add': col.role === 'add', 'col-subtract': col.role === 'subtract' }"
                >
                  {{ col.label }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(row, ri) in reportData.rows"
                :key="ri"
                :class="{ 'row-negative': isRowNegative(row) }"
              >
                <td
                  v-for="col in reportData.columns"
                  :key="col.key"
                  :class="{ 'detalle-text': col.type === 'text', 'detalle-count': col.type === 'count' }"
                >
                  {{ formatDetalleColumn(col, row[col.key]) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="hint" v-else>No hay datos para mostrar.</p>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'RHNominaCalculate',
  data() {
    const now = new Date()
    return {
      permissions: [],
      selectedYear: now.getFullYear(),
      selectedPayrollWeekKey: '',
      companies: [],
      loading: false,
      error: '',
      cutoffPassed: true,
      warning: '',
      calculatingCompany: '',
      showReport: false,
      reportData: null,
      reportTitle: '',
      downloading: false,
    }
  },
  computed: {
    payrollWeeks() {
      return this.buildPayrollWeeks(this.selectedYear)
    },
    selectedPayrollWeek() {
      return this.payrollWeeks.find((week) => week.key === this.selectedPayrollWeekKey) || null
    },
  },
  watch: {
    selectedYear() {
      this.syncWeekSelectionForYear()
    },
    selectedPayrollWeekKey() {
      this.fetchCompanies()
    },
  },
  created() {
    this.fetchCurrentUser()
  },
  methods: {
    hasPerm(permOrPerms) {
      if (!permOrPerms) return false
      const perms = Array.isArray(permOrPerms) ? permOrPerms : [permOrPerms]
      return perms.some((perm) => {
        if (this.permissions.includes(perm)) return true
        return this.permissions.includes(`access_control.${perm}`)
      })
    },
    hasAllPerms(perms) {
      return Array.isArray(perms) && perms.length > 0 && perms.every((perm) => this.hasPerm(perm))
    },
    async fetchCurrentUser() {
      const apiDirectory = process.env.API_DIRECTORY
      try {
        const { data } = await axios.get(`${apiDirectory}/current-user/`, {
          headers: { Authorization: 'Token ' + localStorage.getItem('authToken') },
        })
        this.permissions = data.permissions || []
        if (!this.hasAllPerms(['ui_access_rrhh_nomina', 'ui_access_rrhh_module'])) {
          this.$router.push({ name: 'MainPanel' })
          return
        }
        this.syncWeekSelectionForYear()
      } catch (error) {
        this.$router.push({ name: 'MainPanel' })
      }
    },
    syncWeekSelectionForYear() {
      const weeks = this.payrollWeeks
      if (!weeks.length) {
        this.selectedPayrollWeekKey = ''
        return
      }
      const stillValid = weeks.some((week) => week.key === this.selectedPayrollWeekKey)
      if (!stillValid) {
        this.selectedPayrollWeekKey = weeks[0].key
      }
    },
    buildPayrollWeeks(year) {
      const parsedYear = Number(year)
      if (!Number.isInteger(parsedYear) || parsedYear < 1900) return []
      const startOfYear = new Date(parsedYear, 0, 1)
      const endOfYear = new Date(parsedYear, 11, 31)
      // Week 1 is the Tuesday-Monday week containing January 1; a week
      // belongs to the year its Monday (end date) falls in.
      const offsetBackToTuesday = (startOfYear.getDay() - 2 + 7) % 7
      const weeks = []
      let cursor = new Date(parsedYear, 0, 1 - offsetBackToTuesday)
      let index = 1
      for (;;) {
        const start = new Date(cursor)
        const end = new Date(cursor)
        end.setDate(end.getDate() + 6)
        if (end > endOfYear) break
        weeks.push({
          key: `${parsedYear}-${String(index).padStart(2, '0')}`,
          index,
          startDate: this.toIsoDate(start),
          endDate: this.toIsoDate(end),
        })
        cursor.setDate(cursor.getDate() + 7)
        index += 1
      }
      return weeks
    },
    payrollWeekLabel(week) {
      if (!week) return ''
      return `Semana ${week.index}: ${this.formatShortDate(week.startDate)} al ${this.formatShortDate(week.endDate)}`
    },
    toIsoDate(value) {
      const year = value.getFullYear()
      const month = String(value.getMonth() + 1).padStart(2, '0')
      const day = String(value.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    formatShortDate(dateStr) {
      if (!dateStr) return ''
      const [year, month, day] = dateStr.split('-')
      return `${day}/${month}/${year}`
    },
    formatDate(value) {
      if (!value) return 'No calculado'
      const parsed = new Date(value)
      if (Number.isNaN(parsed.getTime())) return value
      return parsed.toLocaleDateString()
    },
    formatMoney(value) {
      if (value === null || value === undefined || value === '') return 'No calculado'
      const num = Number(value)
      if (Number.isNaN(num)) return String(value)
      return num.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })
    },
    formatTotal(row, value) {
      if (!this.isCalculated(row)) return 'No calculado'
      if (value === null || value === undefined || value === '') return 'Pendiente'
      const num = Number(value)
      if (Number.isNaN(num)) return String(value)
      return num.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })
    },
    formatDetalleCell(value) {
      if (value === null || value === undefined || value === '') return '-'
      const num = Number(value)
      if (Number.isNaN(num)) return String(value)
      return num.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })
    },
    formatDetalleColumn(col, value) {
      if (col.type === 'text') return value || '-'
      if (col.type === 'count') return value === null || value === undefined ? '0' : String(value)
      return this.formatDetalleCell(value)
    },
    isCalculated(row) {
      return row && row.status === 'Calculada'
    },
    isRowNegative(row) {
      return ['nomina_microsip', 'complemento_semanal', 'total_neto'].some((key) => {
        const value = row[key]
        if (value === null || value === undefined || value === '') return false
        return Number(value) < 0
      })
    },
    async fetchCompanies() {
      if (!this.selectedPayrollWeek) {
        this.companies = []
        return
      }
      const week = this.selectedPayrollWeek
      this.loading = true
      this.error = ''
      const apiDirectory = process.env.API_DIRECTORY
      try {
        const { data } = await axios.get(`${apiDirectory}/rrhh/payroll-calculation`, {
          params: { week_start_date: week.startDate, week_end_date: week.endDate },
          headers: { Authorization: 'Token ' + localStorage.getItem('authToken') },
        })
        if (!this.selectedPayrollWeek || week.startDate !== this.selectedPayrollWeek.startDate) {
          return
        }
        this.companies = (data && data.companies) || []
        this.cutoffPassed = Boolean(data && data.cutoff_passed)
        this.warning = (data && data.warning) || ''
      } catch (error) {
        const data = error.response && error.response.data ? error.response.data : {}
        this.error = data.error || 'No se pudieron cargar las empresas.'
        this.companies = []
        this.cutoffPassed = false
        this.warning = ''
      } finally {
        this.loading = false
      }
    },
    async onCalcular(row) {
      if (!row || !row.can_calculate || this.calculatingCompany) return
      const week = this.selectedPayrollWeek
      if (!week) return
      this.calculatingCompany = row.company
      this.error = ''
      const apiDirectory = process.env.API_DIRECTORY
      try {
        await axios.post(
          `${apiDirectory}/rrhh/payroll-calculation/calculate`,
          {
            company: row.company,
            week_start_date: week.startDate,
            week_end_date: week.endDate,
            week_index: week.index,
            year: this.selectedYear,
          },
          { headers: { Authorization: 'Token ' + localStorage.getItem('authToken') } }
        )
        await this.fetchCompanies()
      } catch (error) {
        const data = error.response && error.response.data ? error.response.data : {}
        this.error = data.error || 'No se pudo calcular la nomina.'
      } finally {
        this.calculatingCompany = ''
      }
    },
    async openReport(row, report, title) {
      if (!row || !this.isCalculated(row)) return
      const week = this.selectedPayrollWeek
      if (!week) return
      this.error = ''
      const apiDirectory = process.env.API_DIRECTORY
      try {
        const { data } = await axios.get(`${apiDirectory}/rrhh/payroll-calculation/detail`, {
          params: { company: row.company, week_start_date: week.startDate, report },
          headers: { Authorization: 'Token ' + localStorage.getItem('authToken') },
        })
        this.reportData = data
        this.reportTitle = title
        this.showReport = true
      } catch (error) {
        const data = error.response && error.response.data ? error.response.data : {}
        this.error = data.error || 'No se pudo cargar el reporte.'
      }
    },
    closeReport() {
      this.showReport = false
    },
    async downloadReport(format) {
      if (!this.reportData || this.downloading) return
      this.downloading = true
      const apiDirectory = process.env.API_DIRECTORY
      try {
        const response = await axios.get(`${apiDirectory}/rrhh/payroll-calculation/download`, {
          params: {
            company: this.reportData.company,
            week_start_date: this.reportData.week_start_date,
            report: this.reportData.report,
            file_format: format,
          },
          headers: { Authorization: 'Token ' + localStorage.getItem('authToken') },
          responseType: 'blob',
        })
        const blob = new Blob([response.data])
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        const disposition = response.headers['content-disposition'] || ''
        const match = disposition.match(/filename="?([^"]+)"?/)
        const extByFormat = { csv: 'csv', xlsx: 'xlsx', banregio: 'xlsx' }
        link.download = match ? match[1] : `reporte.${extByFormat[format] || 'xlsx'}`
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      } catch (error) {
        this.error = 'No se pudo descargar el reporte.'
      } finally {
        this.downloading = false
      }
    },
    onDetalle(row) {
      this.openReport(row, 'detalle', 'Detalle de nomina')
    },
    onRepBanco(row) {
      this.openReport(row, 'rep_banco', 'Rep. Banco')
    },
    onDispersion(row) {
      this.openReport(row, 'dispersion', 'Dispersion')
    },
    onPrestamos(row) {
      this.openReport(row, 'complemento', 'Complemento')
    },
    // --- Button handler (functionality to be implemented later) ---
    onCerrar() {},
    backMainPanel() {
      this.$router.push({ path: '/main-panel' })
    },
    goBackToMenu() {
      this.$router.push({ path: '/modulo-personal/nomina' })
    },
  },
}
</script>

<style scoped>
.main-panel {
  --bg: #f7f8fb;
  --muted: #667085;
  --text: #0f172a;
  --brand: #ffc434;
  --brand-ink: #3a2a00;
  --primary: #2563eb;
  --ring: rgba(37, 99, 235, 0.25);
  min-height: 100vh;
  background: var(--bg);
  padding: 12vh 24px 48px;
}
.nav-bar-operations {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 10vh;
  background-color: var(--brand);
  z-index: 1000;
  display: flex;
  align-items: center;
  padding-left: 16px;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.05);
}
.logo-button {
  height: 55%;
  object-fit: contain;
  cursor: pointer;
}
.header {
  margin: 12px auto 0;
  max-width: 1200px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
.header__left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.avatar {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  background: linear-gradient(135deg, var(--brand), #ffe188);
  color: var(--brand-ink);
  font-weight: 800;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);
}
.greet h1 {
  font-size: 1.15rem;
  color: var(--text);
  margin: 0;
}
.greet h1 span {
  font-weight: 700;
}
.greet .sub {
  margin: 2px 0 0;
  color: var(--muted);
  font-size: 0.9rem;
}
.back-btn {
  border: 1px solid rgba(0, 0, 0, 0.12);
  background: #fff;
  color: var(--text);
  border-radius: 12px;
  padding: 10px 14px;
  cursor: pointer;
}
.back-btn:hover {
  background: #f1f5f9;
}

.content {
  margin: 18px auto 0;
  max-width: 1200px;
  width: 100%;
}
.content--wide {
  max-width: none;
}
.controls {
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  padding: 16px 18px;
  display: flex;
  align-items: flex-end;
  gap: 16px;
  flex-wrap: wrap;
}
.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 0.85rem;
  color: var(--muted);
}
.field.grow {
  flex: 1;
  min-width: 280px;
}
.field input,
.field select {
  padding: 9px 10px;
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  font-size: 0.95rem;
  color: var(--text);
  background: #fff;
}
.week-note {
  color: var(--muted);
  font-size: 0.82rem;
  padding-bottom: 10px;
}
.refresh-btn {
  margin-left: auto;
  border: none;
  background: var(--primary);
  color: #fff;
  border-radius: 10px;
  padding: 10px 16px;
  font-weight: 600;
  cursor: pointer;
}
.refresh-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.table-wrap {
  margin-top: 16px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}
.payroll-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8rem;
  color: var(--text);
  table-layout: fixed;
}
.payroll-table th,
.payroll-table td {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  padding: 8px 6px;
  text-align: center;
  word-break: break-word;
  overflow-wrap: anywhere;
}
.payroll-table thead th {
  background: #f1f5f9;
  font-weight: 700;
  color: #334155;
  position: sticky;
  top: 0;
}
.payroll-table .text-left {
  text-align: left;
}
.company-cell {
  font-weight: 600;
}
.empty-cell {
  padding: 24px;
  color: var(--muted);
}

.status-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 600;
}
.status-badge--pending {
  background: #fef3c7;
  color: #92400e;
  border: 1px solid #fde68a;
}
.status-badge--ok {
  background: #dcfce7;
  color: #166534;
  border: 1px solid #bbf7d0;
}

.calc-btn {
  background: var(--primary);
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 7px 10px;
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
}
.calc-btn:not(:disabled):hover {
  box-shadow: 0 6px 16px rgba(37, 99, 235, 0.3);
}
.calc-btn:disabled {
  background: #cbd5e1;
  color: #f8fafc;
  cursor: not-allowed;
}
.missing-file {
  margin-top: 4px;
  font-size: 0.68rem;
  color: #b45309;
  white-space: nowrap;
}
.report-actions {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 4px;
}
.report-btn {
  flex: 1 1 0;
  min-width: 0;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.18);
  border-radius: 8px;
  padding: 6px 3px;
  font-size: 0.66rem;
  cursor: pointer;
  color: var(--text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.report-btn:not(:disabled):hover {
  background: #f1f5f9;
  border-color: var(--primary);
}
.report-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.close-btn {
  background: #fff;
  border: 1px solid #dc2626;
  color: #dc2626;
  border-radius: 8px;
  padding: 6px 10px;
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
}
.close-btn:not(:disabled):hover {
  background: #fef2f2;
}
.close-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  border-color: #cbd5e1;
  color: #94a3b8;
}

.detalle-view {
  margin-top: 16px;
}
.detalle-header {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 12px;
}
.detalle-header h2 {
  margin: 0;
  font-size: 1.05rem;
  color: var(--text);
}
.detalle-sub {
  margin-left: 8px;
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--muted);
}
.report-download {
  margin-left: auto;
  display: flex;
  gap: 8px;
}
.dl-btn {
  border: none;
  border-radius: 10px;
  padding: 9px 14px;
  font-weight: 600;
  font-size: 0.85rem;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.2s ease, opacity 0.2s ease;
}
.dl-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.dl-btn--csv {
  background: #000000;
  color: #ffffff;
}
.dl-btn--xlsx {
  background: #d5171d;
  color: #ffffff;
}
.dl-btn--banregio {
  background: #ee7a17;
  color: #ffffff;
}
.dl-btn:not(:disabled):hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
}
.detalle-wrap {
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  overflow-x: auto;
}
.detalle-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.78rem;
  color: var(--text);
  white-space: nowrap;
}
.detalle-table th,
.detalle-table td {
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 6px 10px;
  text-align: right;
}
.detalle-table thead th {
  background: #f1f5f9;
  color: #334155;
  text-align: center;
  position: sticky;
  top: 0;
}
.detalle-table thead th.col-add {
  background: #cffafe;
  color: #155e75;
}
.detalle-table thead th.col-subtract {
  background: #fee2e2;
  color: #991b1b;
}
.detalle-table tbody tr:nth-child(even) {
  background: #f8fafc;
}
.detalle-table tbody tr:hover {
  background: #e0f2fe;
}
.detalle-table tbody tr.row-negative,
.detalle-table tbody tr.row-negative:hover {
  background: #fecaca;
}
.detalle-table .detalle-text {
  text-align: left;
}
.detalle-table .detalle-count {
  text-align: center;
  font-weight: 600;
}
.detalle-table td.detalle-text:first-child {
  font-weight: 600;
}

.definitions {
  margin: 18px auto 0;
  max-width: 520px;
}
.definitions h3 {
  text-align: center;
  font-size: 0.95rem;
  color: var(--text);
  margin: 0 0 8px;
}
.definitions-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  overflow: hidden;
  font-size: 0.85rem;
}
.definitions-table td {
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 7px 12px;
  color: var(--text);
}
.definitions-table td:first-child {
  font-weight: 600;
  background: #f8fafc;
  width: 55%;
}

.error-box {
  margin-top: 14px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #991b1b;
  border-radius: 12px;
  padding: 12px 16px;
}
.warning-box {
  margin-top: 14px;
  background: #fffbeb;
  border: 1px solid #fde68a;
  color: #92400e;
  border-radius: 12px;
  padding: 12px 16px;
}
.warning-box p {
  margin: 6px 0 0;
}

@media (max-width: 720px) {
  .header {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
}
</style>
